module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<label class=\"dropdown-label mb-2\">")
    ; __append(escapeFn( locals.label ))
    ; __append("</label> <div class=\"dropdown\"> <button class=\"btn btn-clear btn-block dropdown-toggle\" data-toggle=\"dropdown\" role=\"button\"> ")
    ; __append(escapeFn( locals.currentChoice.readable ))
    ; __append(" </button> <ul class=\"dropdown-menu\"> ")
    ;  _(locals.choices).each(function(choice) { 
    ; __append(" <li data-option=\"")
    ; __append(escapeFn( choice.option ))
    ; __append("\" class=\"dropdown-item\">")
    ; __append(escapeFn( choice.readable ))
    ; __append("</li> ")
    ;  }); 
    ; __append(" <li> <div id=\"loader\" class=\"loader\"></div> </li> </ul> ")
    ;  if (locals.chargeableType === 'BankAccount') { 
    ; __append(" <p class=\"small text-muted mt-2\"> Bank Account transfers take up to 5 business days to process and require verification to be complete. </p> ")
    ;  } 
    ; __append(" </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/billing/account_balance/payment_method_selector.ejs
// module id = 1259
// module chunks = 1